const defaultTheme = {
  shadow: '0.2px 0.2px 1px 0px #191B1E66',
  padding: '10px 0',
};

export { defaultTheme };
